import { z } from 'zod'

import { MAX_USER_TRIAL_EXTENSION_DAYS } from '@/api/internal'
import { DAY_MS, utcDay } from '@/utils/dates'

export const utcDateISO = utcDay

export const minTrialDateISO = (): string => utcDateISO(new Date())

// Backend rejects end-of-day UTC beyond now + 365 days, so the last accepted date is today + 364.
export const maxTrialDateISO = (): string =>
  utcDateISO(new Date(Date.now() + (MAX_USER_TRIAL_EXTENSION_DAYS - 1) * DAY_MS))

export const trialSchema = z
  .object({
    user_email: z.string().email('Please enter a valid email'),
    trial_end: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Enter a date (YYYY-MM-DD)'),
  })
  .superRefine((data, ctx) => {
    const min = minTrialDateISO()
    const max = maxTrialDateISO()
    if (data.trial_end < min) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['trial_end'],
        message: 'Trial end date must be today (UTC) or later.',
      })
    }
    if (data.trial_end > max) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['trial_end'],
        message: `Trial end date must be on or before ${max}.`,
      })
    }
  })

export type TrialFormValues = z.infer<typeof trialSchema>
